<template>
  <el-form class="tw-flex tw-gap-x-6">
    <div class="tw-w-full tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-flex tw-gap-x-6 tw-gap-y-3 tw-items-start">
      <i-form-item
        class="tw-max-w-xs placeholder-as-label"
      >
        <MultiSelectWithSearch
          v-model="filters.notification_types"
          option-object-label-key="name"
          :options="notificationTypeSelectOptions"
          :label="$t('notifications.filters.type')"
          :handle-change="(payload) => updateFilter('notification_types', payload)"
        >
          <template #icon="{ item }">
            <NotificationTypeIcon
              class="tw-text-gray-dark tw-mr-2 tw-ml-[-4px]"
              :type="item.id"
            />
          </template>
        </MultiSelectWithSearch>
      </i-form-item>

      <div class="tw-flex tw-gap-3 tw-w-full">
        <i-form-item
          class="tw-max-w-xs placeholder-as-label"
        >
          <MultiSelectWithSearch
            v-model="filters.flags"
            option-object-label-key="name"
            :options="flags"
            :label="$t('notifications.filters.flag_color')"
            :handle-change="(payload) => updateFilter('flags', payload)"
          >
            <template #icon="{ item }">
              <div
                class="tw-w-2 tw-h-2 tw-rounded-full tw-mr-2  tw-ml-[-4px]"
                :class="[
                  item.id === 10 ? 'tw-bg-primary' : '',
                  item.id === 20 ? 'tw-bg-permit-1' : '',
                  item.id === 30 ? 'tw-bg-permit-5' : '',
                  item.id === 40 ? 'tw-bg-permit-4' : '',
                  item.id === 50 ? 'tw-bg-permit-3' : '',
                ]"
              />
            </template>
          </MultiSelectWithSearch>
        </i-form-item>
        <i-button
          v-if="someFilterSelected"
          is-icon
          size="large"
          @click="resetFilters"
        >
          <icon-close />
        </i-button>
      </div>
    </div>
    <div class="tw-flex-1 tw-h-min tw-flex">
      <DebouncedSearch
        :query="searchQuery"
        :search="search"
        :placeholder="$t('common.actions.search')"
      />
    </div>
  </el-form>
</template>

<script>
import DebouncedSearch from '@/components/shared/DebouncedSearch.vue';
import MultiSelectWithSearch from '@/components/shared/MultiSelectWithSearch.vue';
import NotificationTypeIcon from '@/components/Notifications/NotificationTypeIcon.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: { NotificationTypeIcon, MultiSelectWithSearch, DebouncedSearch },
  data() {
    return {
      searchQuery: '',
      notificationTypeSearch: '',
    };
  },

  computed: {
    ...mapState({
      filters: (state) => state.v2.shared.notifications.filters,
      notificationTypeSelectOptions: (state) => [...state.v2.shared.enums.enums.notification_types].sort((a, b) => a.name.localeCompare(b.name)),
      flags: (state) => state.v2.shared.notifications.flags,
    }),
    ...mapGetters({
      someFilterSelected: 'v2/shared/notifications/someFilterSelected',
    }),
  },

  mounted() {
    this.searchQuery = this.$store.state.v2.shared.notifications.filters.search;
  },

  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/shared/notifications/updateFilter', { field, payload });
    },

    resetFilters() {
      this.$emit('reset');
    },

    search(query) {
      this.$store.commit('v2/shared/notifications/updateFilter', { field: 'search', payload: query });
    },
  },
};
</script>
